<div [ngStyle]="mapDivStyle()">
<div class='lgr_col'>
  <div class='lgr_10 col_01'><dynamic-field [id]='"scrndt"' [size]=10 [line]=1 [column]=1 [(ngModel)]='scrndt'></dynamic-field></div>
  <div class='lgr_08 col_13'><dynamic-field [id]='"scrntm"' [size]=8 [line]=1 [column]=13 [(ngModel)]='scrntm'></dynamic-field></div>
  <div class='lgr_12 col_35'><span class='brt high default' id='text1'>NRPC - STARS</span>  </div>
  <div class='lgr_05 col_75'><span class='brt high default' id='text2'>S102G</span>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_51 col_12'><span class='brt high default' id='text3'>CREDIT CARD SECURITY AUTHORIZATION TABLE LISTING OF</span>  </div>
  <div class='lgr_14 col_64'><dynamic-field [id]='"hdrtag"' [size]=14 [line]=3 [column]=64 [(ngModel)]='hdrtag'></dynamic-field></div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_07 col_01'><span class='brt high default' id='text4'>USER ID</span>  </div>
  <div class='lgr_09 col_10'><span class='brt high default' id='text5'>ADMIN IND</span>  </div>
  <div class='lgr_11 col_21'><span class='brt high default' id='text6'>CC VIEW IND</span>  </div>
  <div class='lgr_14 col_33'><span class='brt high default' id='text7'>EFFECTIVE DATE</span>  </div>
  <div class='lgr_14 col_49'><span class='brt high default' id='text8'>EFFECTIVE TIME</span>  </div>
  <div class='lgr_15 col_64'><span class='brt high default' id='text9'>EXPIRATION DATE</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><span class='brt high default' id='text10'>-------------------------------------------------------------------------------</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"line01"' [size]=79 [line]=7 [column]=1 [(ngModel)]='line01'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"line02"' [size]=79 [line]=8 [column]=1 [(ngModel)]='line02'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"line03"' [size]=79 [line]=9 [column]=1 [(ngModel)]='line03'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"line04"' [size]=79 [line]=10 [column]=1 [(ngModel)]='line04'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"line05"' [size]=79 [line]=11 [column]=1 [(ngModel)]='line05'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"line06"' [size]=79 [line]=12 [column]=1 [(ngModel)]='line06'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"line07"' [size]=79 [line]=13 [column]=1 [(ngModel)]='line07'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"line08"' [size]=79 [line]=14 [column]=1 [(ngModel)]='line08'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"line09"' [size]=79 [line]=15 [column]=1 [(ngModel)]='line09'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"line10"' [size]=79 [line]=16 [column]=1 [(ngModel)]='line10'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"line11"' [size]=79 [line]=17 [column]=1 [(ngModel)]='line11'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"line12"' [size]=79 [line]=18 [column]=1 [(ngModel)]='line12'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"line13"' [size]=79 [line]=19 [column]=1 [(ngModel)]='line13'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"line14"' [size]=79 [line]=20 [column]=1 [(ngModel)]='line14'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"line15"' [size]=79 [line]=21 [column]=1 [(ngModel)]='line15'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"msgln"' [size]=79 [line]=22 [column]=1 [(ngModel)]='msgln'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_04 col_01'><span class='brt high default' id='text11'>PF: </span>  </div>
  <div class='lgr_06 col_08'><span class='brt high default' id='text12'>3-EXIT</span>  </div>
  <div class='lgr_08 col_16'><span class='brt high default' id='text13'>4-RETURN</span>  </div>
  <div class='lgr_09 col_26'><span class='brt high default' id='text14'>7-PAGE UP</span>  </div>
  <div class='lgr_11 col_37'><span class='brt high default' id='text15'>8-PAGE DOWN</span>  </div>
  <div class='lgr_13 col_50'><span class='brt high default' id='text16'>10-FIRST PAGE</span>  </div>
  <div class='lgr_12 col_65'><span class='brt high default' id='text17'>11-LAST PAGE</span>  </div>
</div>
</div>
